import DateBox from 'devextreme-react/date-box';
import { LoadPanel } from 'devextreme-react/load-panel';
import { SelectBox } from 'devextreme-react/select-box';
import React from 'react';
import Modal from 'react-modal'; //npm install --save react-modal
import Swal from 'sweetalert2';
import { formatDate, getRequestParams } from '../../helpers/globalfunctions';
import { SendEmailComponent } from '../Shared/SendEmailComponent';
const position = { of: '#historydiv' };

export class InvoiceReportComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSubmited: false,
            isEmailSubmitted: false,
            isOpenModal: false,
            loadPanelVisible: false,
            chkCustomerTypeSelection: "1",
            dropdownCustomerType: [],
            customerTypeId: 0,

            chkCustomerSelection: "1",
            dropdownCustomer: [],
            customerCode: '',

            chkInvoiceSelection: "1",
            invoiceNumber: '',

            chkPeriodSelection: "1",
            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(),

            chkReportTypeSelection: "1",
            chkSelectTypeSelection: "1",
            chkOrderBySelection: "1",

            errors: {
                customerTypeId: '',
                customerCode: '',
                invoiceNumber: '',

            }
        }
        this.getCustomerType = this.getCustomerType.bind(this);
        this.handleCustomerTypeChange = this.handleCustomerTypeChange.bind(this);
        this.handleCustomerTypeSelectionChange = this.handleCustomerTypeSelectionChange.bind(this);

        this.getCustomer = this.getCustomer.bind(this);
        this.handleCustomerChange = this.handleCustomerChange.bind(this);
        this.handleCustomerSelectionChange = this.handleCustomerSelectionChange.bind(this);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInvoiceSelectionChange = this.handleInvoiceSelectionChange.bind(this);

        this.handlePeriodSelectionChange = this.handlePeriodSelectionChange.bind(this);
        this.handleFromDateChanged = this.handleFromDateChanged.bind(this);
        this.handleToDateChanged = this.handleToDateChanged.bind(this);

        this.handleReportTypeSelectionChange = this.handleReportTypeSelectionChange.bind(this);
        this.handleSelectTypeSelectionChange = this.handleSelectTypeSelectionChange.bind(this);
        this.handleOrderBySelectionChange = this.handleOrderBySelectionChange.bind(this);

        this.downloadAccountPaymentTypeSummaryAsPdf = this.downloadAccountPaymentTypeSummaryAsPdf.bind(this);

        this.handleSearchAccountPaySummaryReportSubmit = this.handleSearchAccountPaySummaryReportSubmit.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
    }

    showModal = async () => {
        try {
            this.setState({ isOpenModal: true });
        } catch (ex) {
            console.log(ex);
        }
    }
    handleOnAfterOpenModal = async () => {
        try {
            this.setState({ loadPanelVisible: true });
            await this.getCustomerType();
            await this.getCustomer();
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ loadPanelVisible: false });
    }
    handleOnCloseModal = async () => {

        this.setState({ isOpenModal: false });
        await this.handleClearSearch();
    }

    async getCustomer() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('account-api/customer-dropdown/', requestParams);
            const data = await response.json();
            this.setState({
                dropdownCustomer: data.customers,
            });

        } catch (e) {
            console.log(e);
        }
    }

    handleCustomerChange(selectedOption) {
        this.setState({
            customerCode: (selectedOption.selectedItem !== null ? selectedOption.selectedItem.code : '')
        })
        this.state.errors["customerCode"] = "";
    }

    handleCustomerSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ chkCustomerSelection: value, customerCode: '' });
        this.state.errors["customerCode"] = "";
    }

    async getCustomerType() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('customer-type-api/', requestParams);
            const data = await response.json();
            this.setState({
                dropdownCustomerType: data.customerType,
            });

        } catch (e) {
            console.log(e);
        }
    }

    handleCustomerTypeChange(selectedOption) {
        this.setState({ customerTypeId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["customerTypeId"] = "";
    }

    handleCustomerTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;

        this.setState({ chkCustomerTypeSelection: value, customerTypeId: '' });
        this.state.errors["customerTypeId"] = "";
    }

    handleInvoiceSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;

        this.setState({ chkInvoiceSelection: value, invoiceNumber: '' });
        this.state.errors["invoiceNumber"] = "";
    }


    handlePeriodSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;

        this.setState({ chkPeriodSelection: value });
    }

    handleReportTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;

        this.setState({ chkReportTypeSelection: value });
    }

    handleSelectTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;

        this.setState({ chkSelectTypeSelection: value });
    }

    handleOrderBySelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;

        this.setState({ chkOrderBySelection: value });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === "invoiceNumber") {
            const re = /^[0-9\b]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                this.setState({ [name]: event.target.value })
            }
        } else {
            this.setState({
                [name]: value
            });
        }
    }

    handleFromDateChanged(event) {
        let fromDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ startDate: fromDateValue })
    }
    handleToDateChanged(event) {
        let toDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ endDate: toDateValue })
    }


    handleSearchAccountPaySummaryReportSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.downloadAccountPaymentTypeSummaryAsPdf();
        }
    }
    handleClearSearch() {
        this.setState({
            isSubmited: false,
            isEmailSubmitted: false,
            loadPanelVisible: false,
            chkCustomerTypeSelection: "1",
            customerTypeId: 0,

            chkCustomerSelection: "1",
            customerCode: '',

            chkInvoiceSelection: "1",
            invoiceNumber: '',

            chkPeriodSelection: "1",
            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(),

            chkReportTypeSelection: "1",
            chkSelectTypeSelection: "1",
            chkOrderBySelection: "1",

            errors: {
                customerTypeId: '',
                customerCode: '',
                invoiceNumber: '',

            }
        });
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.customerCode = "";
        errors.customerTypeId = "";
        errors.invoiceNumber = "";

        if (this.state.chkCustomerTypeSelection === "2" && this.state.customerTypeId === 0) {
            formIsValid = false;
            errors.customerTypeId = "Please select customer type.";
        }
        if (this.state.chkCustomerSelection === "2" && this.state.customerCode === "") {
            formIsValid = false;
            errors.customerCode = "Please select customer.";
        }

        if (this.state.chkInvoiceSelection === "2" && this.state.invoiceNumber === "") {
            formIsValid = false;
            errors.invoiceNumber = "Please enter invoice number.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }
    async downloadAccountPaymentTypeSummaryAsPdf() {
        try {
            this.setState({
                isSubmited: true,
            });
            var szSQL = "";
            var fileName = "";

            var request = new Object();
            request.LocationId = Number(sessionStorage.getItem("session_locationId"));
            if (this.state.chkCustomerTypeSelection === "1") {

                if (this.state.chkCustomerSelection === "2") {
                    szSQL = szSQL + " " + (szSQL.length > 0 ? " AND " : "").toString() + "+ {MM_INVOICE.ACCOUNT_CODE} ='" + this.state.customerCode + "'";
                }
                if (this.state.chkInvoiceSelection === "2") {
                    szSQL = szSQL + " " + (szSQL.length > 0 ? " AND " : "").toString() + " {MM_INVOICE.INVOICE_NO} =" + parseInt(this.state.invoiceNumber);
                }

                if (this.state.chkPeriodSelection === "2") {
                    szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_INVOICE.INVOICE_DATE} In CDateTime (" + formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01) to CDateTime (" + formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59) ";
                }

                request.SelectionCrieteria = szSQL;
                request.MethodName = "GetInvoiceSummaryByAllCustomerType";
                fileName = "InvoiceSummaryByAllCustomerType";
            } else if (parseInt(this.state.customerTypeId) === 6) {
                if (this.state.chkReportTypeSelection === "2") {
                    if (this.state.chkCustomerSelection === "2") {
                        szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_INVOICE.ACCOUNT_CODE} ='" + this.state.customerCode + "' ";
                    }
                    if (this.state.chkInvoiceSelection === "2") {
                        szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_INVOICE.INVOICE_NO} =" + parseInt(this.state.invoiceNumber);
                    }
                    if (this.state.chkPeriodSelection === "2") {
                        szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + " {PROC_Rpt_INVoucher_Details;1.INVOICE_DATE} In CDateTime (" + formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01) to CDateTime (" + formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59) ";
                    }
                    request.SelectionCrieteria = szSQL;
                    request.MethodName = "GetInvoiceDetailsByTourOperator";
                    fileName = "InvoiceDetailsByTourOperator";
                } else {
                    szSQL = "{MM_INVOICE.ACCOUNT_TYPE} = 'VOUCHER/TOUR OPERATOR'";
                    if (this.state.chkCustomerSelection === "2") {
                        szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_INVOICE.ACCOUNT_CODE} ='" + this.state.customerCode + "' ";
                    }
                    if (this.state.chkInvoiceSelection === "2") {
                        szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_INVOICE.INVOICE_NO} =" + parseInt(this.state.invoiceNumber);
                    }
                    if (this.state.chkPeriodSelection === "2") {
                        szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_ACCOUNTS.INVOICE_DATE} In CDateTime (" + formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01) to CDateTime (" + formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59) ";
                    }
                    request.SelectionCrieteria = szSQL;
                    request.MethodName = "GetInvoiceSummaryByTourOperator";
                    fileName = "InvoiceSummaryByTourOperator";
                }
            } else {
                if (this.state.chkReportTypeSelection === "2") {
                    request.CustomerTypeId = parseInt(this.state.customerTypeId);
                    request.AccountCode = this.state.customerCode;
                    request.InvoiceNo = this.state.invoiceNumber === "" ? 0 : parseInt(this.state.invoiceNumber);
                    request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy");

                    request.SelectionCrieteria = szSQL;
                    request.MethodName = "GetInvoiceDetailsByOtherCustomer";
                    fileName = "InvoiceDetailsByOtherCustomer";
                } else {
                    let puZone = this.state.dropdownCustomerType.find(opt => opt.id === this.state.customerTypeId);
                    szSQL = "{PROC_Rpt_INCustomer_Summary;1.ACCOUNT_TYPE}= '" + puZone.name + "'";
                    if (this.state.chkCustomerSelection === "2") {
                        szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{PROC_Rpt_INCustomer_Summary;1.ACCOUNT_CODE} ='" + this.state.customerCode + "' ";
                    }
                    if (this.state.chkInvoiceSelection === "2") {
                        szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{PROC_Rpt_INCustomer_Summary;1.INVOICE_NO} <=" + parseInt(this.state.invoiceNumber);
                    }
                    if (this.state.chkPeriodSelection === "2") {
                        szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{PROC_Rpt_INCustomer_Summary;1.INVOICE_DATE} In CDateTime (" + formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01) to CDateTime (" + formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59) ";
                    }
                    request.SelectionCrieteria = szSQL;
                    request.MethodName = "GetInvoiceSummaryByOtherCustomer";
                    fileName = "InvoiceSummaryByOtherCustomer";
                }
            }

            request.fileFormat = 'pdf';
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('crystal-report-api', requestParams);
            const dataResponse = await response.json();
            this.setState({
                isSubmited: false,
            });

            let a = document.createElement('a');
            a.href = dataResponse.reportBase64String;
            a.download = fileName + '.pdf';

            a.click();
        } catch (e) {
            this.setState({
                isSubmited: false,
            });
            console.log(e)
        }
    }
    handleOnSendEmail = async (event) => {
        event.preventDefault();
        try {
            if (this.handleValidation()) {
                this.setState({ isEmailSubmitted: true });
                var szSQL = "";
                var fileName = "";
                var request = new Object();
                request.LocationId = Number(sessionStorage.getItem("session_locationId"));
                if (this.state.chkCustomerTypeSelection === "1") {

                    if (this.state.chkCustomerSelection === "2") {
                        szSQL = szSQL + " " + (szSQL.length > 0 ? " AND " : "").toString() + "+ {MM_INVOICE.ACCOUNT_CODE} ='" + this.state.customerCode + "'";
                    }
                    if (this.state.chkInvoiceSelection === "2") {
                        szSQL = szSQL + " " + (szSQL.length > 0 ? " AND " : "").toString() + " {MM_INVOICE.INVOICE_NO} =" + parseInt(this.state.invoiceNumber);
                    }

                    if (this.state.chkPeriodSelection === "2") {
                        szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_INVOICE.INVOICE_DATE} In CDateTime (" + formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01) to CDateTime (" + formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59) ";
                    }

                    request.SelectionCrieteria = szSQL;
                    request.MethodName = "GetInvoiceSummaryByAllCustomerType";
                    fileName = "InvoiceSummaryByAllCustomerType";
                } else if (parseInt(this.state.customerTypeId) === 6) {
                    if (this.state.chkReportTypeSelection === "2") {
                        if (this.state.chkCustomerSelection === "2") {
                            szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_INVOICE.ACCOUNT_CODE} ='" + this.state.customerCode + "' ";
                        }
                        if (this.state.chkInvoiceSelection === "2") {
                            szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_INVOICE.INVOICE_NO} =" + parseInt(this.state.invoiceNumber);
                        }
                        if (this.state.chkPeriodSelection === "2") {
                            szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + " {PROC_Rpt_INVoucher_Details;1.INVOICE_DATE} In CDateTime (" + formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01) to CDateTime (" + formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59) ";
                        }
                        request.SelectionCrieteria = szSQL;
                        request.MethodName = "GetInvoiceDetailsByTourOperator";
                        fileName = "InvoiceDetailsByTourOperator";
                    } else {
                        szSQL = "{MM_INVOICE.ACCOUNT_TYPE} = 'VOUCHER/TOUR OPERATOR'";
                        if (this.state.chkCustomerSelection === "2") {
                            szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_INVOICE.ACCOUNT_CODE} ='" + this.state.customerCode + "' ";
                        }
                        if (this.state.chkInvoiceSelection === "2") {
                            szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_INVOICE.INVOICE_NO} =" + parseInt(this.state.invoiceNumber);
                        }
                        if (this.state.chkPeriodSelection === "2") {
                            szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{MM_ACCOUNTS.INVOICE_DATE} In CDateTime (" + formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01) to CDateTime (" + formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59) ";
                        }
                        request.SelectionCrieteria = szSQL;
                        request.MethodName = "GetInvoiceSummaryByTourOperator";
                        fileName = "InvoiceSummaryByTourOperator";
                    }
                } else {
                    if (this.state.chkReportTypeSelection === "2") {
                        request.CustomerTypeId = parseInt(this.state.customerTypeId);
                        request.AccountCode = this.state.customerCode;
                        request.InvoiceNo = this.state.invoiceNumber === "" ? 0 : parseInt(this.state.invoiceNumber);
                        request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy");

                        request.SelectionCrieteria = szSQL;
                        request.MethodName = "GetInvoiceDetailsByOtherCustomer";
                        fileName = "InvoiceDetailsByOtherCustomer";
                    } else {
                        let puZone = this.state.dropdownCustomerType.find(opt => opt.id === this.state.customerTypeId);
                        szSQL = "{PROC_Rpt_INCustomer_Summary;1.ACCOUNT_TYPE}= '" + puZone.name + "'";
                        if (this.state.chkCustomerSelection === "2") {
                            szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{PROC_Rpt_INCustomer_Summary;1.ACCOUNT_CODE} ='" + this.state.customerCode + "' ";
                        }
                        if (this.state.chkInvoiceSelection === "2") {
                            szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{PROC_Rpt_INCustomer_Summary;1.INVOICE_NO} <=" + parseInt(this.state.invoiceNumber);
                        }
                        if (this.state.chkPeriodSelection === "2") {
                            szSQL = szSQL + (szSQL.length > 0 ? " AND " : "").toString() + "{PROC_Rpt_INCustomer_Summary;1.INVOICE_DATE} In CDateTime (" + formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01) to CDateTime (" + formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59) ";
                        }
                        request.SelectionCrieteria = szSQL;
                        request.MethodName = "GetInvoiceSummaryByOtherCustomer";
                        fileName = "InvoiceSummaryByOtherCustomer";
                    }
                }

                request.fileFormat = 'pdf';
                const requestParams = getRequestParams('POST', request);
                const response = await fetch('crystal-report-api', requestParams);
                const dataResponse = await response.json();
                this.setState({ isEmailSubmitted: false });
                let fileData = dataResponse.reportBase64String;
                if (fileData !== null && fileData !== '') {
                    let emailSubject = 'Invoice Report';
                    let attachments = [];
                    let file = new Object();
                    file.fileData = fileData;
                    file.fileName = fileName + '.pdf';
                    file.fileExtension = '.pdf';
                    attachments.push(file);
                    this.refs.sendEmailComponent.showModal('', '', emailSubject, '', attachments);
                }
                else {
                    Swal.fire({
                        allowOutsideClick: false,
                        showCloseButton: true,
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong! Unable to process the email request.',
                    })
                }
            }
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ isEmailSubmitted: false });
    }
    render() {
        return (
            <div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenModal}
                    style={{ content: { width: '53%' } }}
                    className={"react-modal"}
                    onAfterOpen={this.handleOnAfterOpenModal}
                    onRequestClose={this.handleOnCloseModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" onSubmit={this.handleSearchAccountPaySummaryReportSubmit}
                        style={(this.state.isSubmited || this.state.isEmailSubmitted) ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">Invoice Report</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleOnCloseModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllCustomerType" value="1" checked={this.state.chkCustomerTypeSelection === "1"} onChange={this.handleCustomerTypeSelectionChange} />
                                            <label className="form-check-label">All Customer Type</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSingleCustomerType" value="2" checked={this.state.chkCustomerTypeSelection === "2"} onChange={this.handleCustomerTypeSelectionChange} />
                                            <label className="form-check-label">Single Customer Type</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownCustomerType.length > 0 ? this.state.dropdownCustomerType : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select customer type"
                                            name="customerTypeId"
                                            defaultValue={0}
                                            value={this.state.customerTypeId}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleCustomerTypeChange}
                                            showClearButton={true}
                                            disabled={this.state.chkCustomerTypeSelection === "1"}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["customerTypeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["customerTypeId"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllCustomer" value="1" checked={this.state.chkCustomerSelection === "1"} onChange={this.handleCustomerSelectionChange} />
                                            <label className="form-check-label">All Customer</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSingleCustomer" value="2" checked={this.state.chkCustomerSelection === "2"} onChange={this.handleCustomerSelectionChange} />
                                            <label className="form-check-label">Single Customer</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownCustomer.length > 0 ? this.state.dropdownCustomer : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select customer"
                                            name="customerCode"
                                            defaultValue={0}
                                            value={this.state.customerCode}
                                            displayExpr='fullName'
                                            valueExpr='code'
                                            onSelectionChanged={this.handleCustomerChange}
                                            showClearButton={true}
                                            disabled={this.state.chkCustomerSelection === "1"}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["customerCode"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["customerCode"]}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllInvoice" value="1" checked={this.state.chkInvoiceSelection === "1"} onChange={this.handleInvoiceSelectionChange} />
                                            <label className="form-check-label">All Invoice</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSingleInvoice" value="2" checked={this.state.chkInvoiceSelection === "2"} onChange={this.handleInvoiceSelectionChange} />
                                            <label className="form-check-label">Single Invoice</label>
                                        </span>
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-sm" name="invoiceNumber" disabled={this.state.chkInvoiceSelection === "1"} maxLength="30" title="Enter invoice number" value={this.state.invoiceNumber} onChange={this.handleInputChange} placeholder="Enter invoice number" />
                                        </div>
                                        {this.state.errors["invoiceNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["invoiceNumber"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">&nbsp;</label>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllPeriod" value="1" checked={this.state.chkPeriodSelection === "1"} onChange={this.handlePeriodSelectionChange} />
                                            <label className="form-check-label">All Date</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdInRangePeriod" value="2" checked={this.state.chkPeriodSelection === "2"} onChange={this.handlePeriodSelectionChange} />
                                            <label className="form-check-label"> Invoice Date</label>
                                        </span>
                                        <DateBox type="date"
                                            className="form-control form-control-sm"
                                            name="fromDate"
                                            placeholder="mm/dd/yyyy"
                                            useMaskBehavior={true}
                                            defaultValue={this.state.startDate}
                                            value={this.state.startDate}
                                            onValueChanged={this.handleFromDateChanged}
                                            width="100%"
                                            disabled={this.state.chkPeriodSelection === "1"}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12" style={{ display: 'none' }}>
                                    <div className="form-group">
                                        <label>To Date</label>
                                        <DateBox type="date"
                                            className="form-control form-control-sm"
                                            name="toDate"
                                            placeholder="mm/dd/yyyy"
                                            useMaskBehavior={true}
                                            defaultValue={this.state.endDate}
                                            value={this.state.endDate}
                                            onValueChanged={this.handleToDateChanged}
                                            width="100%"
                                            disabled={this.state.chkPeriodSelection === "1"}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">Report Type</label><br />
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSummary" value="1" checked={this.state.chkReportTypeSelection === "1" || this.state.chkCustomerTypeSelection === "1"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Summary</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdDetails" value="2" disabled={this.state.chkCustomerTypeSelection === "1"} checked={this.state.chkReportTypeSelection === "2"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Details</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success btn-sm" onClick={this.handleOnSendEmail} >
                                {this.state.isEmailSubmitted && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isEmailSubmitted && <span title="Send Email"><i className="fas fa-envelope"></i> Send Email</span>}
                            </button>
                            <button type="button" className="btn btn-success btn-sm" title="Download" onClick={this.handleSearchAccountPaySummaryReportSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                                {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span title="Download"><i className="fas fa-file-download"></i> Download</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Clear"
                                onClick={this.handleClearSearch}>
                                <i className="fas fa-eraser"></i> Clear
                                </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Close"
                                onClick={this.handleOnCloseModal}>
                                <i className="fas fa-times"></i> Close
                                </button>
                        </div>
                    </form>
                </Modal>
                <SendEmailComponent ref="sendEmailComponent" />
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div >
        )
    }
}